import { render, staticRenderFns } from "./DrugOrderReturnedItems.vue?vue&type=template&id=70a8537a&"
import script from "./DrugOrderReturnedItems.vue?vue&type=script&lang=js&"
export * from "./DrugOrderReturnedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports